import { BRANDS } from "@/data/brands";

export default function BrandsStrip() {
  return (
    <section className="py-8 md:py-10">
      <div className="container">
        <div className="rounded-2xl border border-border/60 bg-white px-6 py-8 shadow-sm md:px-10 md:py-10">
          <div className="mb-7 text-center md:mb-9">
            <h2 className="text-xl font-semibold tracking-tight text-ink md:text-2xl">Brands we install</h2>
            <div className="mx-auto mt-3 h-0.5 w-12 rounded-full bg-brand" />
          </div>
          {/* Mobile: wraps centred. Desktop: one flat, evenly-spaced line. */}
          <div className="flex flex-wrap items-center justify-center gap-x-10 gap-y-6 md:flex-nowrap md:justify-between md:gap-x-6">
            {BRANDS.map((b) => (
              <img
                key={b.slug}
                src={b.logo}
                alt={b.name}
                title={b.name}
                className="h-9 w-auto md:h-9"
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
